import CompLayout from "@/pcomponents/comp_stu/layout/layout";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import getXcolumnJson from "./xcolumn/list";
import ListSearchComponent from "../corse_list/area/list_search";
import ListCardComponent from "./area/list_area";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import ArrFunc from '@/lib/lyg/arr_func';

function MyVideoList() {
  let user = useSelector((state: any) => state.user);
  const navigate = useNavigate();
  const xColumnArr = getXcolumnJson();
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    "s_addon_title_img": "1",
    "s_addon_section": "1",
    "s_addon_video": "1",
    "s_addon_use_stu": "1",
    "s_addon_request": "1",
    "s_category_seq": "",
    "s_stu_seq": user.user_seq,
  });
  const [infoArr, setInfoArr] = useState([]); // Set rowData to Array of Objects, one Object per Row
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [categoryInfoArr, setCategoryInfoArr] = useState([]);
  const [viewSort, setViewSort] = useState("list");//list,view
  const [is_checked_textbook_use, set_is_checked_textbook_use] = useState(false);
  const ListSearchComponentRef = useRef<any>(null);
  const ListCardComponentRef = useRef<any>(null);

  useEffect(() => {
    list({});
    list_category();
  }, [user.user_seq]);

  const list = (inOptObj: any) => {
    let change_list_opt = {
      ...listOpt,
      ...inOptObj,
    };
    setListOpt(change_list_opt);
    if (user.user_seq == "") {
      return false;
    }
    change_list_opt.s_mcomp_seq = "";
    change_list_opt.s_stu_seq = user.user_seq;
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/video/corse/list', change_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          for (let i = 0; i < response.data["data"]["info_arr"].length; i++) {
            let info = response.data["data"]["info_arr"][i];
            if (info.use_stu_arr && info.use_stu_arr.length > 0) {
              let tmp_use_info = info.use_stu_arr[0];
              if (tmp_use_info.a_update_date) {
                response.data["data"]["info_arr"][i]["use_time_stamp"] = new Date(tmp_use_info.a_update_date).getTime();
              }
            }
          }
          response.data["data"]["info_arr"] = ArrFunc.get_sorted_arr_of_json_by_key({
            arr: response.data["data"]["info_arr"],
            key: "use_time_stamp",
            sort: "-"
          });
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          if (ListCardComponentRef.current) {
            ListCardComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
          }
          let tmp_corse_pri_val_arr: any = [];
          for (let i = 0; i < response.data["data"]["info_arr"].length; i++) {
            tmp_corse_pri_val_arr.push(response.data["data"]["info_arr"][i]["row_pri_val"]);
          }
          check_textbook_use_period_video_by_ajax({
            except_corse_pri_val_arr: tmp_corse_pri_val_arr
          });
        } else {

        }
      });
  };

  const check_textbook_use_period_video_by_ajax = (inData: any) => {
    let opt_obj = {
      except_corse_pri_val_arr: [],
      ...inData
    };

    let form_json_data: any = {
      stu_seq: user.user_seq,
      except_corse_pri_val_arr: opt_obj.except_corse_pri_val_arr
    };
    if (user.user_seq == "") {
      return false;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/video/use/check_by_textbook_use', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data.data && response.data.data.is_exist_new_add) {
            if (is_checked_textbook_use == false) {
              list({});
            }
          }
        } else {

        }
        set_is_checked_textbook_use(true);
      });
  };

  const list_category = () => {
    let category_form_json = {
      "s_mcomp_seq": "1",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/video/category/list', category_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setCategoryInfoArr(response.data["data"]["info_arr"]);
          if (ListSearchComponentRef.current) {
            ListSearchComponentRef.current.setCategoryInfoArr(response.data["data"]["info_arr"]);
          }
        } else {

        }
      });
  };

  return (
    <CompLayout>
      <div className="stu_con_wrap">
        <div className="text-right">
          <button className="btn-m btn-yellowish2" onClick={() => { navigate("/comp_stu/video/corse_list"); }}>모든과정보기</button>
        </div>
        {viewSort == "list" &&
          <div className="mt-2">
            <ListSearchComponent
              ref={ListSearchComponentRef}
              categoryInfoArr={categoryInfoArr}
              listOpt={listOpt}
              list={(inOpt: any) => { list(inOpt); }}
            ></ListSearchComponent>
            <ListCardComponent
              ref={ListCardComponentRef}
              xColumnArr={xColumnArr}
              onClickRow={(inOptObj: any) => {
                navigate('/comp_stu/video/my_list_view',
                  { state: { row_data: inOptObj.data } });
              }}
              is_show_iam_ing={false}
            ></ListCardComponent>
            <Paging now_page={listOpt.now_page}
              num_per_page={listOpt.num_per_page}
              total_rec={countInfo.tot}
              onChangePage={(now_page: number) => { list({ now_page: now_page }); }}></Paging>
          </div>
        }
      </div>
    </CompLayout>
  );
}

export default MyVideoList;